import { useEffect, useState } from 'react';
import { isIos, isStandalone, onInstallAvailable, promptInstall } from '../lib/pwa';

const DISMISSED = 'iran.install.dismissed';

/**
 * A quiet invitation to put Ìran on the home screen.
 *
 * It appears once. If the family says no it stays gone, because nagging a
 * grandmother to install something is exactly the behaviour this product exists
 * to be the opposite of.
 */
export function InstallPrompt() {
  const [available, setAvailable] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISSED) === '1';
    } catch {
      return false;
    }
  });
  const [showIosSteps, setShowIosSteps] = useState(false);

  useEffect(() => onInstallAvailable(setAvailable), []);

  const ios = isIos();
  if (isStandalone() || dismissed) return null;
  if (!available && !ios) return null;

  const close = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISSED, '1');
    } catch {
      /* private browsing — the banner simply returns next visit */
    }
  };

  return (
    <div className="install-card" role="complementary" aria-label="Add Ìran to your home screen">
      <img src="/icon-192.png" alt="" width={44} height={44} />
      <div className="stack tight">
        <strong>Keep Ìran on your home screen</strong>
        <span className="muted small">Opens like an app, and the lessons still open when the signal drops.</span>
        {showIosSteps && (
          <span className="muted small">
            Tap <strong>Share</strong> at the bottom of Safari, then <strong>Add to Home Screen</strong>.
          </span>
        )}
      </div>
      <div className="row">
        {ios && !available ? (
          <button className="btn small" onClick={() => setShowIosSteps(true)}>
            How
          </button>
        ) : (
          <button
            className="btn small"
            onClick={async () => {
              const accepted = await promptInstall();
              if (accepted) close();
            }}
          >
            Add
          </button>
        )}
        <button className="btn small ghost" onClick={close} aria-label="No thanks">
          Not now
        </button>
      </div>
    </div>
  );
}
